<form [formGroup]="form" class="form card-body-modal">
  <h2 *ngIf="data.iban != ''">Rekening niet gevonden</h2>
  <p>Wilt u de rekening aanmaken?</p>
  <!-- AccountNumber -->
  <div [ngClass]="{ 'input-error': submitted && f.accountNumber.errors }">
    <label class="form-label" for="accountNumber">IBAN</label>
    <input formControlName="accountNumber" class="extended" id="accountNumber" type="text">
    <div class="errors">
      <div *ngIf="f.accountNumber.errors?.required">rekeningnummer is verplicht</div>
      <div *ngIf="f.accountNumber.errors?.validAccountNumber">rekeningnummer is geen correct iban</div>
    </div>
  </div>

  <!-- AccountName -->
  <div [ngClass]="{ 'input-error': submitted && f.accountCategoryId.errors }">
    <label class="form-label"
           for="accountCategoryId">type rekening</label>
    <app-select [options]="accountCategories"
                formControlName="accountCategoryId"
                [extended]="true"
                id="accountCategoryId"
                labelIndex="name"
                valueIndex="id"></app-select>
    <div class="errors">
      <div *ngIf="f.accountCategoryId.errors?.required">type rekening is verplicht</div>
    </div>
  </div>

  <div class="spacer-large"></div>
  <div class="flex space-between">
    <button (click)="close(false)" class="btn btn-left arrow-left">annuleer</button>
    <button (click)="create(form.value)" class="btn accent inverted plus ">opslaan</button>
  </div>
  <div class="spacer-small"></div>
</form>
